"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accessible_name_1 = require("./accessible-name");
exports.computeAccessibleName = accessible_name_1.computeAccessibleName;
var getRole_1 = require("./getRole");
exports.getRole = getRole_1.default;
